import { render } from "./Cicp.vue?vue&type=template&id=52987213&scoped=true"
const script = {}

import "./Cicp.css?vue&type=style&index=0&id=52987213&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52987213"]])

export default __exports__